/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowARightIcon32Regular = forwardRef('ArrowARightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M18.043 6.207a1 1 0 0 1 1.414-1.414l8.379 8.378a4 4 0 0 1 0 5.657l-8.379 8.379a1 1 0 1 1-1.414-1.414l8.379-8.379c.126-.127.232-.266.318-.414H4a1 1 0 1 1 0-2h22.74a2.005 2.005 0 0 0-.318-.414l-8.38-8.379Z" })));
});
